/** Accessible checkbox. Wraps React Aria Checkbox. */
import {
  Checkbox as AriaCheckbox,
  type CheckboxProps as AriaCheckboxProps,
} from 'react-aria-components';
import { Check } from 'lucide-react';
import { cn } from '@/foundation/utils/cn';

interface CheckboxProps extends Omit<AriaCheckboxProps, 'children'> {
  children?: React.ReactNode;
  className?: string;
}

export function Checkbox({ children, className, ...props }: CheckboxProps) {
  return (
    <AriaCheckbox
      className={cn(
        'group flex items-center gap-2 text-sm transition-colors',
        'cursor-pointer data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50',
        className
      )}
      {...props}
    >
      {(renderProps) => (
        <>
          <span
            className={cn(
              'flex h-4 w-4 flex-shrink-0 items-center justify-center rounded transition-all duration-150',
              renderProps.isFocusVisible && 'ring-2 ring-[var(--f-accent)] ring-offset-1'
            )}
            style={{
              background: renderProps.isSelected ? 'var(--f-accent)' : 'transparent',
              border: renderProps.isSelected ? 'none' : '1.5px solid var(--f-border-strong)',
            }}
          >
            {renderProps.isSelected && <Check size={12} strokeWidth={2.5} color="white" />}
          </span>
          {children}
        </>
      )}
    </AriaCheckbox>
  );
}
